import styles from './index.module.scss';

const Loading = () => {
  return (
    <div className={styles['retentionOfferLoading']}>
      <div id="details">
        <div id="name" />
        <div id="description" />
      </div>
      <div id="button" />
    </div>
  );
};

export default Loading;
